/** Tier sets, one per class (crafting.md §5). Set ids are stable save data (TIER_SET_IDS). */
import type { TierSetDef } from '../../types';
import { BLADEMASTER_SET } from './blademaster';
import { LIGHTBINDER_SET } from './lightbinder';
import { STORMCALLER_SET } from './stormcaller';
import { WARDEN_SET } from './warden';

export { BLADEMASTER_SET, LIGHTBINDER_SET, STORMCALLER_SET, WARDEN_SET };
export const TIER_SETS: readonly TierSetDef[] = [WARDEN_SET, BLADEMASTER_SET, LIGHTBINDER_SET, STORMCALLER_SET];
